<template>
  <v-dialog v-model="openDialog" fullscreen>
    <v-card class="fullscreen-dialog">
      <v-container>
        <v-row class="payment-container" align="center" justify="center">
          <v-col cols="8">
            <div
              v-if="!dobbyMessage && !isTransactionFinish"
              class="card text-center"
            >
              <img src="@/assets/ic-payment-card-options.png" alt="" />

              <v-btn
                block
                class="py-7 mt-5 payment-button"
                color="primary"
                @click="handleOperationCard(debitOperation)"
                @click.right="handleOperationCard(debitOperation)"
              >
                debito
              </v-btn>

              <v-btn
                block
                class="py-7 mt-5 payment-button"
                color="secondary"
                @click="handleOperationCard(creditOperation)"
                @click.right="handleOperationCard(creditOperation)"
              >
                credito
              </v-btn>

              <v-divider class="my-10"></v-divider>
              <v-btn
                block
                class="py-7 mt-5 payment-button"
                @click="goBack"
                @click.right="goBack"
                color="white"
                ><v-icon class="pr-4">mdi-arrow-left</v-icon> voltar</v-btn
              >
            </div>
            <div v-else-if="dobbyMessage">
              <h1 class="white--text mb-7 text-center">{{ dobbyMessage }}</h1>
            </div>

            <CardReceipt
              v-if="
                isTransactionFinish &&
                isSuccessfulTransaction &&
                !isPrintingReceipt
              "
              :receipt="receipt"
              :invoices="invoices"
              :valueUp="valueUp"
              @handlePrintReceipt="handlePrintReceipt"
              @handleSendReceipt="handleSendReceipt"
              @goBack="goBack"
            />

            <div v-else-if="isPrintingReceipt">
              <Loading
                v-if="isToShowLoading"
                :text="isPrintingReceipt ? 'Imprimindo...' : 'Enviando...'"
              />
              <div v-else-if="!isToShowLoading">
                <h1 class="white--text mb-7 text-center">
                  {{ messageReturnPrintingReceipt }}
                </h1>

                <CardReceipt
                  :receipt="receipt"
                  :invoices="invoices"
                  :valueUp="valueUp"
                  @handlePrintReceipt="handlePrintReceipt"
                  @handleSendReceipt="handleSendReceipt"
                  @goBack="goBack"
                  @userLogout="userLogout"
                  :isEndTheSession="true"
                />
              </div>
            </div>

            <div v-else-if="isTransactionFinish && !isSuccessfulTransaction">
              <h1 v-if="!isTransictionUserCanceled" class="white--text mb-7 text-center">
                {{!isTransictionNotAuthorization ? 'Falha ao efetuar o pagamento, tente novamente!' : 'Transação não autorizada'}}
              </h1>
              <h1 v-else class="white--text mb-7 text-center">
                Operação cancelada.
              </h1>
              <v-btn
                block
                class="py-7 mt-5 payment-button"
                @click="goBack"
                @click.right="goBack"
                color="white"
              >
                <v-icon class="pr-4">mdi-arrow-left</v-icon>
                voltar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import invoicesStore from "@/store/invoices.store";
import adminStore from "@/store/admin.store";

import apiCard from "@/services/apiCard.service";
import { dateFormat, getDateToPT } from "@/services/date.service";
import { formatNumberReal } from "@/services/formatNumber.service";

import Loading from "@/components/Loading/Loading";
import CardReceipt from "@/components/CardReceipt";

import { signOut } from "@/controllers/user.controller";
import paymentController from "@/controllers/payment.controller";

import PaymentModel from "@/models/payment-money.model";

export default {
  name: "PaymentDialog",
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
  },
  components: { Loading, CardReceipt },
  data() {
    return {
      debitOperation: 2,
      creditOperation: 3,
      dobbyMessage: "",
      messageReturnPrintingReceipt: "",
      handleSetInterval: "",
      isTransactionFinish: false,
      isSuccessfulTransaction: false,
      isPrintingReceipt: false,
      isToShowLoading: false,
      isTransictionNotAuthorization: false,
      isTransictionUserCanceled: false, 
      totemName: "",
      fileComp: "",
      receipt: {},
      handleSetTimeout: "",
      time: 240000,
      invoices: [],
      valueUp: "",
    };
  },
  filters: {
    filterFormatNumberRealFormat(value) {
      return formatNumberReal(Number(value));
    },
    filterDatePT(date) {
      return getDateToPT(date);
    },
  },
  methods: {
    handleSetTimeoutOutput() {
      clearTimeout(this.handleSetTimeout);
      signOut();
    },
    handleOperationCard(typeOperation) {
      clearTimeout(this.handleSetTimeout);
      this.handleSetTimeout = setTimeout(
        this.handleSetTimeoutOutput,
        this.time
      );

      this.dobbyMessage = "Processando pagamento...";

      this.invoices = invoicesStore.getters.invoices;

      const paymentModel = new PaymentModel();
      const documentPayment = paymentModel.getData();

      const date = dateFormat(new Date());
      documentPayment.payment_date = date;
      documentPayment.payment_credit_date = date;

      const documentNumbers = [];
      const documentValues = [];
      const documentPaymentForShipping = [];

      for (const invoice of this.invoices) {
        const { document_number, value_up } = invoice;
        documentNumbers.push(document_number);
        documentValues.push(value_up);
        documentPaymentForShipping.push({
          ...documentPayment,
          document_id: invoice.id,
          document_number: invoice.document_number,
          payment_discount_amount: invoice.value_discount,
          payment_interest_amount: invoice.value_interest,
          payment_fine_amount: invoice.value_fine,
          rate_amount: invoice.value_up,
          payment_comment: 'baixa totem avulsa'
        });
      }


      this.valueUp = documentValues
        .reduce((accumulator, currentvalue) => (accumulator += currentvalue))
        .toFixed(2);

      apiCard
        .post("/operationCrt", {
          billPay: documentNumbers.join(),
          valueUp: this.valueUp,
          typeOperation,
          nameUser: this.totemName,
        })
        .then((res) => {
          console.log(res.data);

           if (res.data.codigo === -6 || res.data.codigo === -2) {
            clearInterval(this.handleSetInterval);
            this.isTransactionFinish = true;
            this.isSuccessfulTransaction = false;
            this.dobbyMessage = "";
            this.isTransictionUserCanceled = true;
            return
          }  else if (res.data.codigo === 255) {
            clearInterval(this.handleSetInterval);
            this.isTransactionFinish = true;
            this.isSuccessfulTransaction = false;
            this.isTransictionNotAuthorization = true;
            this.dobbyMessage = "";
            return
          }  else if (res.data.codigo !== 0) {
            clearInterval(this.handleSetInterval);
            this.isTransactionFinish = true;
            this.isSuccessfulTransaction = false;
            this.dobbyMessage = "";
            return;
          }

          clearInterval(this.handleSetInterval);
          this.isTransactionFinish = true;
          this.isSuccessfulTransaction = true;
          this.dobbyMessage = "";

          this.receipt = res.data;

          const receipt = {
            ...this.receipt,
            value:this.valueUp
          }

          paymentController.log(receipt, documentPaymentForShipping);
        })
        .catch((err) => {
          clearInterval(this.handleSetInterval);
          this.isTransactionFinish = true;
          this.isSuccessfulTransaction = false;
          this.dobbyMessage = "";
          console.log(err);
        });

      this.handleReadMessage();
    },
    async handleReadMessage() {
      this.handleSetInterval = setInterval(async () => {
        try {
          const res = await apiCard.get("/readMessage");

          if ( res.data.message === 'Tabelas Atualizados!!!') {
            return;
          }

          this.dobbyMessage = res.data.message;
        } catch (error) {
          console.log(error);
        }
      }, 200);
    },
    handleSendReceipt() {
      const { typeCard, flagCard, nameCard, numberCard, documentNumber, modePay } = this.receipt;

      const invoices = [];

      for (const invoice of this.invoices) {
        invoices.push({
          ...invoice,
          due_date: getDateToPT(invoice.due_date),
          value_up: formatNumberReal(invoice.value_up),
        });
      }

      const receipt = {
        typeCard,
        flagCard,
        nameCard,
        numberCard,
        documentNumber,
        modePay,
        invoices,
        valueUp: formatNumberReal(Number(this.valueUp)),
      };

      this.$emit("handleIsSendingReceipt", receipt);
    },
    handlePrintReceipt() {
      clearTimeout(this.handleSetTimeout);
      this.handleSetTimeout = setTimeout(
        this.handleSetTimeoutOutput,
        this.time
      );

      this.isPrintingReceipt = true;
      this.isToShowLoading = true;
      console.log(`printComprovante file: ${this.receipt.fileComp} totemName: ${this.totemName}`);
      apiCard
        .post("/printComprovante", {
          fileComp: this.receipt.fileComp,
          nameUser: this.totemName,
        })
        .then(() => {
          this.messageReturnPrintingReceipt =
            "Impressão realizada com sucesso.";
          this.isToShowLoading = false;
        })
        .catch((err) => {
          this.messageReturnPrintingReceipt =
            "Erro ao tentar imprimir, tente novamente!";
          this.isToShowLoading = false;
          console.log(err);
        });
    },
    userLogout() {
      clearTimeout(this.handleSetTimeout);
      signOut();
    },
    goBack() {
      clearTimeout(this.handleSetTimeout);
      this.$emit("close", true);
    },
  },
  mounted() {
    const { selectedTotem } = adminStore.getters.admin;
    this.totemName = selectedTotem.name;
    this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
  },
};
</script>



<style scoped>
.fullscreen-dialog .payment-container {
  height: 100vh;
}

.fullscreen-dialog .payment-button {
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4),
    0px 6px 16px rgba(35, 41, 46, 0.2) !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  font-size: 17px !important;
}

.white--text{
    color: #1A237E !important;
}
</style>